"use strict";

var _slicedToArray = require("/app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryFactory = exports.queryWithVariablesFactory = void 0;

var apollo_utilities_1 = require("apollo-utilities");

var react_1 = __importDefault(require("react"));

var helpers_1 = require("./helpers");

var hooks_1 = require("./hooks");

var useQuery = function useQuery(query) {
  var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var saleor = helpers_1.useSaleorClient();
  var didMountRef = react_1.default.useRef(false);
  var prevDataRef = react_1.default.useRef(null);
  var prevUnsubRef = react_1.default.useRef(null);

  var _hooks_1$useAuth = hooks_1.useAuth(),
      authenticated = _hooks_1$useAuth.authenticated;

  var _react_1$default$useS = react_1.default.useState({
    data: null,
    error: null,
    loading: true
  }),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      result = _react_1$default$useS2[0],
      setResult = _react_1$default$useS2[1];

  var setData = react_1.default.useCallback(function (data, loading) {
    if (!apollo_utilities_1.isEqual(data, prevDataRef.current)) {
      prevDataRef.current = data;
      setResult({
        data: data,
        error: null,
        loading: false
      });
    } else {
      setResult(function (previousResult) {
        return Object.assign(Object.assign({}, previousResult), {
          loading: !!loading
        });
      });
    }
  }, []);

  var _react_1$default$useM = react_1.default.useMemo(function () {
    return saleor.legacyAPIProxy[query](variables, Object.assign(Object.assign({}, options), {
      onError: function onError(error) {
        return setResult(function (previousResult) {
          return Object.assign(Object.assign({}, previousResult), {
            error: error,
            loading: false
          });
        });
      },
      onUpdate: function onUpdate(data, loading) {
        setData(data, loading);
      }
    }));
  }, [query, options.skip, authenticated]),
      unsubscribe = _react_1$default$useM.unsubscribe,
      setOptions = _react_1$default$useM.setOptions,
      _refetch = _react_1$default$useM.refetch,
      _loadMore = _react_1$default$useM.loadMore;

  var refetch = react_1.default.useCallback(function (refetchVariables) {
    setResult({
      data: null,
      error: null,
      loading: true
    });

    _refetch(refetchVariables);
  }, [query]);
  var loadMore = react_1.default.useCallback(function (loadMoreVariables) {
    var mergeResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (_loadMore) {
      setResult(function (previousResult) {
        return Object.assign(Object.assign({}, previousResult), {
          error: null,
          loading: true
        });
      });

      _loadMore(loadMoreVariables, mergeResults);
    }
  }, [query]);
  react_1.default.useEffect(function () {
    // skip on initial mount
    if (didMountRef.current) {
      refetch(variables);
    } else {
      didMountRef.current = true;
    }
  }, [JSON.stringify(variables)]); // unsubscribe from watcher on dismount

  react_1.default.useEffect(function () {
    if (prevUnsubRef.current) {
      prevUnsubRef.current();
    }

    prevUnsubRef.current = unsubscribe;
    return function () {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [options.skip, authenticated]);
  return Object.assign(Object.assign({}, result), {
    loadMore: loadMore,
    refetch: refetch,
    setOptions: setOptions
  });
};

exports.queryWithVariablesFactory = function (query) {
  return function (variables, options) {
    return useQuery(query, variables, options);
  };
};

exports.queryFactory = function (query) {
  return function (options) {
    return useQuery(query, undefined, options);
  };
};